import React from 'react';
import { useMultipleSamples } from './useMultipleSamples';

export const SamplesLoader = (props) => {
  const {
    children, page, parentId, sampleLimit, storeId, zipCode
  } = props;
  const sampleData = useMultipleSamples({
    page,
    parentId,
    sampleLimit,
    storeId,
    zipCode
  });

  return children(sampleData);
};
